import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import MaskedInput from 'react-text-mask';

import { changeBoletoAttr, validatorHandlerBlur, getInfosInsureds } from '../../../actions/purchaseActions';
import ErrorMessage from '../error_message/ErrorMessage';
import ButtonStage from '../../standard/button_stage/ButtonStage';

class Boleto extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    const field = {
      name: e.target.name,
      value: e.target.value,
    };

    this.props.changeBoletoAttr(field);
  }

  render() {
    if (!this.props.paymentMethods.find((element) => element.slug === 'boleto').available) return <div />;

    const boletoErrors = this.props.errors.boleto;

    return (
      <div
        className="area-boleto"
        style={{ display: this.props.stepDisplayBoleto !== 1 && this.props.mobile ? 'none' : 'block' }}
      >
        <h4 className="title boleto-title">Responsável pelo pagamento</h4>

        <form className="flex">
          <div className="input-form1">
            <input
              type="text"
              name="name"
              value={this.props.boleto.name}
              placeholder="Nome completo"
              onChange={this.handleChange}
              className={`${boletoErrors.name ? 'with-error' : ''}`}
              onBlur={(e) => this.props.validatorHandlerBlur(e.target.value, 'boleto_name')}
            />
            <ErrorMessage anchor={`boleto_name`} field1="boleto" field2="name" />
          </div>
          <div className="input-form1">
            <MaskedInput
              name="cpf"
              guide={true}
              type="tel"
              placeholder="CPF"
              className={`${boletoErrors.cpf ? 'with-error' : ''}`}
              onChange={this.handleChange}
              value={this.props.boleto.cpf}
              mask={[/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]}
              onBlur={(e) => this.props.validatorHandlerBlur(e.target.value, 'boleto_cpf')}
            />
            <ErrorMessage anchor={`boleto_cpf`} field1="boleto" field2="cpf" />
          </div>
        </form>

        <button className="transfer-infos payment" onClick={(_) => this.props.getInfosInsureds(1)}>
          Copiar dados do primeiro segurado
        </button>

        {this.props.mobile && (
          <React.Fragment>
            <ButtonStage data-cy="step-payment-data" index={3} stage="INSURED_PAYMENT_PURCHASE" />
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default withRouter(
  connect(
    (state) => ({
      boleto: state.purchase.boleto,
      paymentMethods: state.purchase.paymentMethods,
      mobile: state.mobile.mobileActive,
      stepDisplayBoleto: state.purchase.stepDisplayBoleto,
      errors: state.purchase.errors,
    }),
    { changeBoletoAttr, validatorHandlerBlur, getInfosInsureds }
  )(Boleto)
);



// WEBPACK FOOTER //
// ./src/components/purchase/payment_info/Boleto.jsx